@if (bankTransactionDomainWidgetData && initialized) {
    <mvs-widget [widgetData]="bankTransactionDomainWidgetData"></mvs-widget>
}
